import { InvalidateQueryFilters, UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ROLE_END_POINTS } from 'core/constants/endpoints'
import instance from 'core/constants/request'
import { toast } from 'react-toastify'

type ApiResponse = {
    data: any
}

type QueryOptionsWithoutMutationFn = Omit<UseMutationOptions<ApiResponse, AxiosError, number, unknown>, 'mutationFn'>

export const useDeleteRole = (options?: QueryOptionsWithoutMutationFn) => {
    const queryClient = useQueryClient()

    return useMutation<ApiResponse, AxiosError, number>({
        retry: 0,
        ...options,
        mutationFn: async (id: number) => {
            const result = await instance.delete<ApiResponse>(`${ROLE_END_POINTS.delete}`, {
                data: {
                    id
                }
            })

            return result.data
        },
        onSuccess: (res) => {
            queryClient.invalidateQueries([ROLE_END_POINTS.roles] as InvalidateQueryFilters);
            toast.success(`نقش با موفقیت حذف گردید`);
        },
        onError: (e: any) => {
            toast.error(`${e.response?.data?.Message || "خطا در حذف نقش"}`);
        }
    })
}    
